window.addEventListener('DOMContentLoaded', () => {
  // 性別ごと出し分けボタン取得
  const women = document.querySelectorAll('.headerWomen');
  const men = document.querySelectorAll('.headerMen');

  // 出し分けするクラスをすべて取得
  const genderWomen = document.querySelectorAll('.gender__women');
  const genderMen = document.querySelectorAll('.gender__men');

  // スタッフスナップ変更リンククラスをすべて取得
  const staffSnapLinkBase = '/pages/coordinate?coordinate_genre=';
  const staffSnapParamWomen = '2';
  const staffSnapParamMen = '1';
  const staffSnapLinks = document.querySelectorAll('.staffsnap__coordinate__link');

  const spGenderSwitchWomen = document.getElementById('spHeader__genderSwitch__btn--women');
  const spGenderSwitchMen = document.getElementById('spHeader__genderSwitch__btn--men');
  const spGenderSwitchWomenTab = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__tabs__tab--women'
  );
  const spGenderSwitchMenTab = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__tabs__tab--men'
  );
  const brandListWomen = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__linkBlock__subList--brandList--women'
  );
  const brandListMen = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__linkBlock__subList--brandList--men'
  );

  const itemCategoryListWomen = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__linkBlock__subList--itemCategoryList--women'
  );
  const itemCategoryListMen = document.getElementById(
    'spHeader__detailMenu__block__content__searchBlock__linkBlock__subList--itemCategoryList--men'
  );

  const setGenderDisplay = displayGender => {
    if (spGenderSwitchWomen)
      spGenderSwitchWomen.classList.toggle('active', displayGender === 'Women');
    if (spGenderSwitchMen) spGenderSwitchMen.classList.toggle('active', displayGender === 'Men');
    if (spGenderSwitchWomenTab)
      spGenderSwitchWomenTab.classList.toggle('active', displayGender === 'Women');
    if (spGenderSwitchMenTab)
      spGenderSwitchMenTab.classList.toggle('active', displayGender === 'Men');
    if (brandListWomen) brandListWomen.classList.toggle('active', displayGender === 'Women');
    if (brandListMen) brandListMen.classList.toggle('active', displayGender === 'Men');
    if (itemCategoryListWomen)
      itemCategoryListWomen.classList.toggle('active', displayGender === 'Women');
    if (itemCategoryListMen)
      itemCategoryListMen.classList.toggle('active', displayGender === 'Men');

    staffSnapLinks.forEach(staffSnapLink => {
      staffSnapLink.href = `${staffSnapLinkBase}${
        displayGender === 'Men' ? staffSnapParamMen : staffSnapParamWomen
      }`;
    });
    if (women) {
      women.forEach(woman => {
        woman.classList.toggle('active', displayGender === 'Women');
      });
    }
    if (men) {
      men.forEach(man => {
        man.classList.toggle('active', displayGender === 'Men');
      });
    }
    if (genderWomen) {
      genderWomen.forEach(gender => {
        gender.classList.toggle('none', displayGender === 'Men');
      });
    }
    if (genderMen) {
      genderMen.forEach(gender => {
        gender.classList.toggle('none', displayGender === 'Women');
      });
    }
    //コーディネート一覧リフレッシュ
    if (!window.location.pathname.startsWith('/pages/outlet')) {
      if (document.getElementById('coordinateSlede')) {
        showCoordinate();
      }
    }
  };

  let displayGender = window.localStorage.getItem('display_gender');
  if (displayGender === null) {
    setGenderDisplay('Women');
  } else {
    setGenderDisplay(displayGender);
  }

  // ブラウザバックした際に、display_genderを取得して再度表示を切り替える
  window.addEventListener('pageshow', event => {
    let displayGender = window.localStorage.getItem('display_gender');
    if (displayGender === null) {
      setGenderDisplay('Women', true);
    } else {
      setGenderDisplay(displayGender, true);
    }
  });

  if (women) {
    women.forEach(woman => {
      woman.addEventListener('click', () => {
        window.localStorage.setItem('display_gender', 'Women');
        setGenderDisplay('Women');
      });
    });
  }

  if (men) {
    men.forEach(man => {
      man.addEventListener('click', () => {
        window.localStorage.setItem('display_gender', 'Men');
        setGenderDisplay('Men');
      });
    });
  }

  if (spGenderSwitchWomenTab) {
    spGenderSwitchWomenTab.addEventListener('click', () => {
      window.localStorage.setItem('display_gender', 'Women');
      setGenderDisplay('Women');
    });
  }

  if (spGenderSwitchMenTab) {
    spGenderSwitchMenTab.addEventListener('click', () => {
      window.localStorage.setItem('display_gender', 'Men');
      setGenderDisplay('Men');
    });
  }
});
